<template>
  <div class="instagram-stories-grid">
    <div
      class="instagram-stories-grid__lottie-container"
      v-if="gridConfiguration"
    />
    <app-loader-component
      class="instagram-stories-grid__loader"
      v-else
      width="100px"
      height="100px"
    />
  </div>
</template>

<script>
import lottie from "lottie-web";
import AppLoaderComponent from "@/app/shared/components/base/AppLoaderComponent"

export default {
  name: "TheInstagramStoriesGridOverlay",
  components: {
    AppLoaderComponent,
  },
  data: function () {
    return {
      animation: null,
    }
  },
  computed: {
    gridConfiguration: function() {
      return this.$store.getters.getInstagramStoriesGridConfiguration
    },
  },
  methods: {
    async initLottieAnimation() {
      if (!this.gridConfiguration) {
        await this.$store.dispatch('fetchInstagramStoriesGrid')
      }
      this.animation = lottie.loadAnimation({
        container: document.querySelector('.instagram-stories-grid__lottie-container'),
        renderer: 'svg',
        loop: true,
        autoplay: true,
        animationData: this.gridConfiguration,
        name: 'instagram-grid',
      })
    },
    destroyLottieAnimation() {
      this.animation.destroy()
    },
  },
  mounted() {
    this.initLottieAnimation()
  },
  beforeDestroy() {
    this.destroyLottieAnimation()
  },
}
</script>

<style lang="scss">
@import "~@/app/styles/blocks/instagram-stories-grid";
</style>